import React from "react"
import { graphql } from "gatsby"
import {MoreArticles} from "../components/moreArticles/moreArticles";
import {StrapiLayout} from "@klear/open-site";
import {footerData} from "../components/footerData";
const {Helmet} = require("react-helmet");


export default ({ data }) => {
    const categoryPosts = data.allWordpressPost.edges;
    let pageTitle;
    let metaTitle;
    let metaDesc;
        if (categoryPosts.length > 0) {
            switch (categoryPosts[0].node.categories[0].name) {
                case "#data_reports":
                    pageTitle = "Things we’ve learned from data";
                    metaTitle ="Data | Klear";
                    metaDesc ="New research and industry leading data to help your influencer strategy";
                    break;
                case "#klear_updates":
                    pageTitle = "What’s happening on Klear";
                    metaTitle ="New Features | Klear";
                    metaDesc ="Stay on top of Klear’s new feature releases, and learn how to incorporate them into your workflow";
                    break;
                default:
                    pageTitle = "Stay on top of your influencer game";
                    metaTitle ="Strategy | Klear";
                    metaDesc ="See successful influencer marketing campaigns, and boost your strategy";
                    break;
            }
        }
    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDesc} />
            </Helmet>
            <div >
                {categoryPosts.length > 0 &&
                    <MoreArticles
                        mainTitle={pageTitle}
                        posts={categoryPosts}
                        isCategoryPage={true}
                        isLink={false}
                    />
                }
            </div>
        </StrapiLayout>
    );
};
export const query = graphql`
  query($category: String!) {
    allWordpressPost(filter: {categories: {elemMatch: {name: {eq: $category}}}}) {
        edges {
          node {
            date(formatString: "MMMM DD, YYYY")
            title
            content
            slug
            excerpt
            featured_media {
              source_url
            }
            author {
              name
            }
            categories {
              name
              slug
            }
          }
        }
    }
  }
`